import { dateToHumanFormat } from '../../../utils/constants';

const DECISION_STYLES = {
    approved:  'bg-emerald-50 text-emerald-700 ring-emerald-100',
    rejected:  'bg-red-50 text-red-600 ring-red-100',
    default:   'bg-gray-100 text-gray-600 ring-gray-200',
};

function decisionStyle(decision) {
    const key = decision?.toLowerCase();
    return DECISION_STYLES[key] ?? DECISION_STYLES.default;
}

function ApprovalHistory({ item }) {
    return (
        <tr className="hover:bg-gray-50/50 dark:hover:bg-gray-700/30 transition-colors">
            <td className="px-5 py-3.5 text-sm font-medium text-gray-900 dark:text-gray-100 capitalize w-[20%]">
                {item?.admin}
            </td>
            <td className="px-5 py-3.5 w-[12%]">
                <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset capitalize ${decisionStyle(item?.decision)}`}>
                    {item?.decision}
                </span>
            </td>
            <td className="px-5 py-3.5 text-sm text-gray-600 dark:text-gray-400 w-[53%]">
                {item?.comments}
            </td>
            <td className="px-5 py-3.5 text-sm text-gray-400 dark:text-gray-500 w-[15%] whitespace-nowrap">
                {dateToHumanFormat(item?.date)}
            </td>
        </tr>
    );
}

export default ApprovalHistory;
